module.exports = __webpack_public_path__ + "static/media/calendar-clock.a79ac43d.svg";